export default "__VITE_ASSET__936cba82__"